<template>
  <b-container fluid>
    <div class="mx-3">
      <b-row>
        <b-col sm="12" md="7" lg="5" class="p-0 mr-3">
          <div class="iq-email-search d-flex">
            <div style="width: 100%;">
              <div class="form-group mb-0">
                <input class="form-control" id="searchMaterial" @keydown="enterSearch" placeholder="ค้นหา" style="width: 100%; height: 45px;" v-model="search">
                <a class="search-link" @click="filterService"><i class="ri-search-line" /></a>
              </div>
            </div>
          </div>
        </b-col>
        <b-col sm="12" md="3" lg="auto" class="p-0">
          <div class="iq-email-search d-flex">
            <div style="width: 100%;">
              <b-button type="button" variant="primary-custom" class="w-100 btn-min-size" style="height: 45px;" @click="clearfilterService">clear</b-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <br>
    <b-row>
      <b-col cols="12">
        <div class="table-responsive">
          <b-table bordered hover :items="rowsService" :fields="columnsService"
              :current-page="currentPage"
              :per-page="perPage"
              @pagination="onPagination"
              :tbody-tr-class="rowClass" thead-class="table-header-color"
          >
            <template v-slot:cell(no)="data">
              <span class="unselectable">{{ ((currentPage - 1) * perPage) + data.index + 1 }}</span>
            </template>
            <template v-slot:cell(service_no)="data">
              <span>{{ data.item.no || '-' }}</span>
            </template>
            <template v-slot:cell(service_group_name)="data">
              <span>{{ data.item.sg_name || '-' }}</span>
            </template>
            <template v-slot:cell(service_type_name)="data">
              <span>{{ data.item.st_name || '-' }}</span>
            </template>
            <template v-slot:cell(select)="data">
              <div style="display: flex; justify-content: center;">
                <b-button :variant="data.item.is_select ? 'danger' : 'primary-custom'" size="sm" @click="toggleAction(data.item)" style="width: 100px; border-radius: 10px;">
                  {{ data.item.is_select ? 'ยกเลิก' : 'เลือก' }}
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
      </b-col>
    </b-row>
    <b-row style="display: flex; justify-content: center;">
      <b-pagination
        v-model="currentPage"
        :total-rows="rowsService?.length"
        :per-page="perPage"
        align="center"
      />
    </b-row>
  </b-container>
</template>

<style scoped>
</style>

<script>
import Axios from 'axios'
import { xray } from '../../../config/pluginInit'
import Vue from 'vue'
import { configAPI } from '../../../configBase'
export default {
  name: 'serviceSelectModal',
  props: {
    id: { type: String },
    mainServiceSelected: null,
    delList: [],
    oldItem: []
  },
  data () {
    return {
      cln_id: JSON.parse(sessionStorage.getItem('user')).cln_id,
      usr_id: JSON.parse(sessionStorage.getItem('user')).usr_id,
      search: '',
      openModal: false,
      currentPage: 1,
      perPage: 10,
      rowsService: [],
      selectedTemp: [],
      selectedTemp2: [],
      columnsService: [
        { label: 'ลำดับ', key: 'no', class: 'text-center table-size-100-300' },
        { label: 'รหัสบริการ', key: 'service_no', class: 'text-center table-size-200-400' },
        { label: 'หมวดหมู่', key: 'service_group_name', class: 'text-center table-size-200-400' },
        { label: 'ประเภทการใช้งาน', key: 'service_type_name', class: 'text-center table-size-200-400' },
        { label: 'สถานะ', key: 'select', class: 'text-center table-size-200-400' }
      ]
    }
  },
  computed: {},
  async mounted () {
    await this.filterService()
    xray.index()
  },
  methods: {
    async enterSearch (e) {
      if (e.key === 'Enter') {
        await this.filterService()
      }
    },
    async clearfilterService () {
      this.search = ''
      await this.filterService()
    },
    async filterService () {
      let datafilter = {
        serviceId: this.oldItem
      }
      await Axios.request({
        method: 'POST',
        url: `${configAPI.MA_PORT}/api/clinic/${this.cln_id}/serviceforselectNoOldItem?search=${this.search}`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: datafilter
      }).then((res) => {
        let tempData = res.data.data
        this.selectedTemp2 = [ ...this.selectedTemp ]
        let tempCheckSelect = [ ...this.mainServiceSelected, ...this.selectedTemp2 ]
        const selectedTemp = []

        for (let item of tempData) {
          item.type = 'Service'
          item.oldNew = 'new'
          item.lp = item.ser_minimum_price || 0
          item.quantity = ''
          const check = tempCheckSelect?.find((el) => {
            return el.id === item.id
          })
          if (check) {
            item.oldNew = check?.soi_id ? 'old' : 'new'
            item.soi_id = check?.soi_id || null
            item.is_select = true
            selectedTemp.push(item)
          } else {
            item.is_select = false
          }
        }
        this.rowsService = tempData
        /* this.selectedTemp = tempData.filter((el) => {
          return el.is_select
        }) */
        const checkDup = {}
        this.selectedTemp = [ ...selectedTemp, ...this.selectedTemp2 ].filter(el => {
          if (!checkDup[el.id]) {
            checkDup[el.id] = el.id
            return el
          }
        })
      }).catch((err) => {
        this.SwalError(err, 'เกิดข้อผิดพลาด')
      })
    },
    submitAction () {
      return [ this.selectedTemp, this.delList ]
    },
    toggleAction (row) {
      let indexSelected = this.selectedTemp.findIndex(el => el.id === row.id)
      if (!row.is_select) {
        row.status = row?.soi_id ? 'update' : 'add'
        if (indexSelected < 0) {
          this.selectedTemp.push(row)
        } else {
          this.selectedTemp[indexSelected] = row
        }
      } else {
        if (row?.soi_id && (this.delList.find(el => el.soi_id === row.soi_id) === undefined)) {
          this.delList.push(row)
        }
        this.selectedTemp.splice(indexSelected, 1)
      }
      row.is_select = !row.is_select
    },
    onPagination (page) {
      this.currentPage = page
    },
    rowClass (item, type) {
      if (!item || type !== 'row') return
      if (item.index % 2 === 1) return 'table-body-color'
    },
    SwalError (error, message) {
      Vue.swal.fire({
        title: `<span class="" style="font-size: 25px; color: black; text-align: center">${message}</span>`,
        html: '<span>' + error + '</span>',
        icon: 'warning',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ตกลง</b-button>',
        confirmButtonColor: '#089bab',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1'
        }
      })
    }
  }
}
</script>
